export namespace TagsActions{
    export class SetAllTags {
        static readonly type = '[Tags] SetAllTags';
        constructor() {}
    }

    // Unlike SetAllTags, always refetches regardless of whether tags are
    // already loaded. Dispatch after an item is created/updated, since a
    // brand new tag may have just been introduced.
    export class RefreshAllTags {
        static readonly type = '[Tags] RefreshAllTags';
        constructor() {}
    }
}
